export * from './list/contratoList.component';
export * from './create/contratoCreate.component';
export * from './edit/contratoEdit.component';
export * from './detail/contratoDetail.component';
export * from './search/contratoSearch.component';
export * from './contrato.service';
export * from './tab/tab.component';
export * from './contrato.component';